import { gql } from '@apollo/client'
import PropTypes from 'prop-types'

export const eventResultFragment = gql`
  fragment eventResult on EventResult {
    id
    slug
    name
    startDate
    endDate
    locationName
    cityName
    country {
      name
      code
    }
  }
`

export const eventResultFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  slug: PropTypes.string,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  locationName: PropTypes.string,
  cityName: PropTypes.string,
  country: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
})
